<script lang="ts">
  import type { IconName } from '@/ui/base';

  import CTAButton from '../../../buttons/CTAButton.svelte';

  let loading = $state(false);

  let {
    onclick,
    icon,
    label = 'KI-Vorschlag laden',
  }: { onclick?: () => Promise<unknown> | unknown; label?: string; icon?: IconName } = $props();

  async function onLoadingClick() {
    if (!onclick) return;
    try {
      loading = true;
      await onclick();
    } finally {
      loading = false;
    }
  }
</script>

<CTAButton variant="primary" {label} {loading} {icon} onclick={onLoadingClick}>{label}</CTAButton>
